import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-image-config',
  templateUrl: './d-image-config.component.html',
  styles: []
})
export class DImageConfigComponent extends DynamicComponentBase {
  static KEY = 'd-image-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (!config.width) {
      config.width = '200';
    }
    if (!config.height) {
      config.height = '200';
    }
  }
}
